<template>
    <td role="cell" :style="containerStyle" :class="containerClass" :data-p-frozen-column="frozen">
        <div>
            <span>{{ value }}</span>
        </div>
    </td>
</template>

<script>
import DomHandler from '@/common/DOMUtils.js';

export default {
    name: 'EditableFooterCell',
    props: {
        value: [String, Number],
        rowIndex: {
            type: Number,
            default: null
        },
        columnIndex: {
            type: Number,
            default: null
        },
        frozen: {
            type: Boolean,
            default: false
        },
        alignFrozen: {
            type: String,
            default: 'left',
            validator: value => ['left', 'right'].includes(value)
        },
        cellStyle: {
            type: Object,
            default: () => {}
        },
        cellStyleCallback: {
            type: Function,
            default: null
        },
        cellClass: {
            type: String,
            default: ''
        },
        cellClassCallback: {
            type: Function,
            default: null
        }
    },
    computed: {
        containerStyle() {
            let style = this.frozen ? [this.styleObject] : [];

            if (this.cellStyle) {
                style.push(this.cellStyle);
            }

            /*if (this.cellStyleCallback) {
                const renderStyle = this.cellStyleCallback({
                    fieldKey: this.columnKey,
                    rowKey: this.rowKey,
                    row: this.rowIndex,
                    column: this.columnIndex,
                    data: this.value
                });

                if (renderStyle) {
                    if (Array.isArray(renderStyle)) {
                        style = style.concat(renderStyle);
                    } else {
                        style.push(renderStyle);
                    }
                }
            }*/

            return style;
        },
        containerClass() {
            let renderClass = 'md-editable-grid-cell-footer';

            /*if (this.cellClassCallback) {
                renderClass = this.cellClassCallback({
                    fieldKey: this.columnKey,
                    rowKey: this.rowKey,
                    row: this.rowIndex,
                    column: this.columnIndex,
                    data: this.value
                });
            }*/

            let frozenClass = '';
            if (this.frozen) {
                frozenClass = 'table-frozen-column';
            }

            return [this.cellClass ?? '', renderClass, frozenClass].filter(x => x.length !== 0);
        }
    },
    data() {
        return {
            styleObject: {}
        };
    },
    methods: {
        updateStickyPosition() {
            if (this.frozen) {
                let align = this.alignFrozen;

                if (align === 'right') {
                    let right = 0;
                    let next = DomHandler.getNextElementSibling(
                        this.$el,
                        '[data-p-frozen-column="true"]'
                    );

                    if (next) {
                        right = DomHandler.getOuterWidth(next) + parseFloat(next.style.right || 0);
                    }

                    this.$set(this.styleObject, 'insetInlineEnd', right + 'px');
                } else {
                    let left = 0;
                    let prev = DomHandler.getPreviousElementSibling(
                        this.$el,
                        '[data-p-frozen-column="true"]'
                    );

                    if (prev) {
                        left = DomHandler.getOuterWidth(prev) + parseFloat(prev.style.left || 0);
                    }

                    this.$set(this.styleObject, 'insetInlineStart', left + 'px');
                }
            }
        }
    },

    mounted() {
        if (this.frozen) {
            this.updateStickyPosition();
        }
    },

    updated() {
        if (this.frozen) {
            this.updateStickyPosition();
        }
    }
};
</script>
